import { z } from "zod";

/**
 * Class Type Schema - ประเภทคลาส (Style)
 */
export const ClassTypeSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  status: z.enum(["active", "inactive"]),
  createdBy: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type ClassTypeDTO = z.infer<typeof ClassTypeSchema>;

/**
 * Create Class Type Schema
 */
export const CreateClassTypeSchema = z.object({
  name: z.string().min(1, "ຊື່ຕ້ອງບໍ່ວ່າງ"),
  description: z.string().nullable().optional(),
  status: z.enum(["active", "inactive"]).default("active"),
});
export type CreateClassTypeDTO = z.infer<typeof CreateClassTypeSchema>;

/**
 * Update Class Type Schema
 */
export const UpdateClassTypeSchema = z.object({
  name: z.string().min(1, "ຊື່ຕ້ອງບໍ່ວ່າງ").optional(),
  description: z.string().nullable().optional(),
  status: z.enum(["active", "inactive"]).optional(),
});
export type UpdateClassTypeDTO = z.infer<typeof UpdateClassTypeSchema>;
